import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  return (
    <div className="payment-page">
      <Helmet>
        <title>Success Page</title>
        <meta property="og:title" content="Success Page" />
        <meta
          property="og:description"
          content="Thank you for your payment. Your booking has been confirmed."
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/major-hotel/image/upload/hotels/images/jrwpujtxnkaqgtqmyvvo"
        />
      </Helmet>

      <h2 className="payment-success">Payment Successful!</h2>
      <p>Thank you for your payment.</p>
      <p>Your booking has been confirmed.</p>

      <Link to="/home" className="home-button">
        Return to Homepage
      </Link>
    </div>
  );
};

export default PaymentSuccess;
